module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      'background-image': 'url(' + _vm.options.src + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lang),
      expression: "!lang"
    }],
    staticClass: "one-title"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.options.title) + "\n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "one-sub-title"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lang),
      expression: "!lang"
    }],
    staticClass: "phone-fade"
  }, [_vm._v("/ ")]), _vm._v(_vm._s(_vm.options.subTitle) + "\n\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t" + _vm._s(_vm.options.intro) + "\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2f023caa"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/banner/banner.vue
// module id = 66
// module chunks = 15